import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../eiraa_mock';

const EiraaHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      {/* Top bar */}
      {!isScrolled && (
        <div className="bg-slate-900 text-white py-2">
          <div className="container mx-auto px-4 flex justify-between items-center text-sm">
            <div className="flex items-center gap-6">
              <a href={`tel:${companyInfo.phone}`} className="flex items-center gap-2 hover:text-amber-300 transition-colors">
                <Phone size={14} />
                <span>{companyInfo.phone}</span>
              </a>
              <a href={`mailto:${companyInfo.email}`} className="hidden sm:flex items-center gap-2 hover:text-amber-300 transition-colors">
                <Mail size={14} />
                <span>{companyInfo.email}</span>
              </a>
            </div>
            <div className="text-xs text-gray-300">Proudly Made in UAE</div>
          </div>
        </div>
      )}

      {/* Main header */}
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_62116a6f-10ce-41f6-9d09-087f8531a25f/artifacts/pi6mf5vx_logo.png" 
              alt="FASTFIX Logo" 
              className="h-12 md:h-16 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`transition-colors font-light ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-300'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`transition-colors font-light ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-300'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className={`transition-colors font-light ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-300'
              }`}
            >
              Products
            </button>
            <button
              onClick={() => scrollToSection('benefits')}
              className={`transition-colors font-light ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-300'
              }`}
            >
              Benefits
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`transition-colors font-light ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-300'
              }`}
            >
              Contact
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-amber-600 hover:bg-amber-700 text-white"
            >
              Get Quote
            </Button>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className={`md:hidden transition-colors ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 flex flex-col gap-4 bg-white rounded-lg p-4 shadow-lg">
            <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-amber-600 transition-colors font-light text-left">
              Home
            </button>
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-amber-600 transition-colors font-light text-left">
              About
            </button>
            <button onClick={() => scrollToSection('products')} className="text-gray-700 hover:text-amber-600 transition-colors font-light text-left">
              Products
            </button>
            <button onClick={() => scrollToSection('benefits')} className="text-gray-700 hover:text-amber-600 transition-colors font-light text-left">
              Benefits
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-amber-600 transition-colors font-light text-left">
              Contact
            </button>
            <Button onClick={() => scrollToSection('contact')} className="bg-amber-600 hover:bg-amber-700 text-white w-full">
              Get Quote
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default EiraaHeader;